import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PriceGroupApprovalPage } from './price-group-approval.page';

const routes: Routes = [
  {
    path: '',
    component: PriceGroupApprovalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PriceGroupApprovalPageRoutingModule {}
